import DailyStatement from 'features/advance/screens/manageAdvanceAccount/advanceStatements/DailyStatements/DailyStatement';
import React from 'react';

export default function DailyStatementPage() {
  return <DailyStatement />;
}
